<template>
  <div>
    <no-data v-if="!lessonsList.length && dataLoadState"></no-data>
    <div v-if="this.notiFicationShow === true && statusTab !=='COMPLETION'" class="notification-header shadow-bottom ">

		<div class="container container--narrow pdt-16 pdb-16">
			<div class="d-flex align-items-center pdb-8"><span class="notification-icon min-w-36 min-h-36"><i
						class="material-icons t-color-secondaryBtnText">notifications</i></span>
				<div class="t-body2 font-m l-spacing42 pdl-16 t-line-h-26">
          {{$t('143', {str: nextLessonName})}}
				</div>
			</div>
			<div class="d-flex justify-content-end">
        <button class="mdc-button  t-color-secondaryBtnText" tabindex="0" @click="learnLesson(nextLessonData)" @keypress="learnLesson(nextLessonData)">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body3">
            {{$t('144')}}
          </span>
				</button></div>
		</div>
	</div>

    <div v-if="lessonsList.length" class="container container--narrow pdt-30">
      <div class="mdc-card  mgb-50 pdb-8">
        <div class="t-headline7 font-m  mgb-16 mgr-12 pdt-24 pdl-24">{{$t('145')}}</div>
        <div v-for="(lesson, index) in lessonsList" :key="index" :class="statusTab == 'WAITING'?'':'cursor-pointer'"
             class="d-flex pdt-16 mgl-24 my-course-list position-relative" tabindex="0" @click.prevent="learnLesson(lesson)" @keypress.prevent="learnLesson(lesson)">
          <div class="list-image-small40">

            <img v-if="lesson.contentsType.value === 'EXAM_PAPER'" src="@/images/icon/test.svg" />
            <img v-else-if="lesson.contentsType.value === 'LIVE_SESSION'" src="@/images/icon/live_sesson.svg"  />
            <img v-else src="@/images/icon/study.svg"  />

            <div v-if="statusTab != 'WAITING'" class="h-2 position-relative total-percentage-course mgt-8 mgb-4 bg-iconinactiveText">
              <div v-if="lesson && lesson.rate" :style="`width:${lesson.rate}%;`" class="real-percentage bg-bodyBlueGray h-2 "></div>
              <!-- <div v-else-if="lesson.contentsType.value==='LIVE_SESSION' && liveProgressRate" class="real-percentage bg-bodyBlueGray h-2 " :style="`width:${liveProgressRate}%;`"></div> -->
            </div>
            <div v-if="lesson && lesson.rate && statusTab != 'WAITING'"  class="t-body3 t-color-bodyBlueGray t-center font-r">{{parseInt(lesson.rate)}}%</div>
            <div v-else-if="statusTab != 'WAITING'"  class="t-body3 t-color-bodyBlueGray t-center font-r">0%</div>
            <!-- <div v-else-if="lesson.contentsType.value==='LIVE_SESSION' && liveProgressRate" class="t-body3 t-color-bodyBlueGray t-center font-r">{{parseInt(liveProgressRate)}}%</div> -->
          </div>
          <div class="flex-grow-1 pdl-20">
            <div class="mgb-16 min-h-72">
              <div class="t-body1 mgb-4  font-r pdr-24 l-spacing48">
                {{lesson.name}}
              </div>
              <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA">
                <!-- <span>{{$t(lesson.contentsType.translate=='code.contentsType.interactiveHtml'?'3166':lesson.contentsType.translate)}} :</span> -->
                <div v-if="lesson.contentsType.translate === 'code.contentsType.interactiveHtml' && lesson.resourceType && lesson.resourceType.translate !== 'code.lessonResourceType.computerScience'">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('3166'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('3166'):$t('146')}} </div>
                <div v-else-if="lesson.contentsType.translate === 'code.contentsType.cegos' && lesson.resourceType && lesson.resourceType.translate !== 'code.lessonResourceType.computerScience'">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('4828'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('4828'):$t('146')}} </div>
                <div v-else-if="lesson.contentsType.translate === 'code.contentsType.interactiveHtml' && lesson.resourceType && lesson.resourceType.translate === 'code.lessonResourceType.computerScience'" class="d-flex" v-html="getMediaTypeString(lesson, '3737')"></div>
                <div v-else-if="lesson.contentsType.translate === 'code.contentsType.liveSession'">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('3305'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('3305'):$t('146')}} </div>
                <div v-else-if="lesson.contentsType.translate === 'code.contentsType.video' && lesson.resourceType && lesson.resourceType.translate !== 'code.lessonResourceType.computerScience'">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('100'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('100'):$t('146')}} </div>
                <div v-else-if="lesson.contentsType.translate === 'code.contentsType.video' && lesson.resourceType && lesson.resourceType.translate === 'code.lessonResourceType.computerScience'" class="d-flex" v-html="getMediaTypeString(lesson, '3736')"></div>
                <div v-else-if="lesson.contentsType.translate === 'code.contentsType.slide'">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('101'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('101'):$t('146')}} </div>
                <div v-else-if="lesson.contentsType.translate === 'code.contentsType.pdf'">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('102'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('102'):$t('146')}} </div>
                <div v-else-if="lesson.contentsType.translate === 'code.contentsType.html'">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('103'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('103'):$t('146')}} </div>
                <div v-else-if="lesson.contentsType.translate === 'code.contentsType.examPaper'">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('148'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('148'):$t('146')}} </div>
                <div v-else>{{ lesson.status.value === 'OPENED' && lesson.rate < 100? $t(lesson.contentsType.translate):$t('146')}} </div>
                <!-- <span>{{$t(lesson.contentsType.translate)}} :</span> -->
                <span v-if="lesson.status.value === 'WAITING'">
                <!-- 학습대기 -->
              </span>
                <span v-else-if="lesson.status.value === 'OPENED'">
                <!-- {{lesson.rate < 100 ? $t('144') : $t('146')}} -->
                  <!-- 학습중 -->
              </span>
              </div>

              <div v-if="lesson.livesessionInfo && lesson.livesessionInfo.timezone" class="mgt-3">
                <div class=" d-flex align-items-baseline">
                  <div class="t-body6  font-r pdr-6 l-spacing45 t-color-bodyGrayA">
                    {{lesson.livesessionInfo.timezone.text}}
                  </div>
                  <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA mgt-3" v-html="convertTimeZone(lesson.livesessionInfo.startDate,lesson.livesessionInfo.timezone.key)">
                  </div>
                </div>
                <div class="mgt-4 d-flex">
                  <!-- <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA">{{$t('3308',{'str1':year,'str2':month,'str3':day})}}: </div> -->
                  <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA" v-html="convertTDuration(lesson.livesessionInfo.duration)"></div>
                </div>
              </div>
					</div>
				</div>
				<div v-if="lesson.learningMaterials.length> 0 && statusTab !== 'WAITING'" class="pdr-24"><i
						class="material-icons t-color-iconInactiveText cursor-pointer"
        tabindex="0" @click.stop="donwloadFile(lesson.learningMaterials[0])" @keypress.stop="donwloadFile(lesson.learningMaterials[0])">download</i>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
/**
 * 나의 학습 상세 - 레슨 컴포넌트(my learning view - lesson component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import learnApi from "@/api/learnApi.js";
import { fileMixin } from "@/mixins/file.js";
import NoData from "../../common/NoDataLesson.vue";

export default {
  components: {
    "no-data": NoData,
  },

  props:['basicData', 'todayDate'],

  data() {
    return {
      lessonData: null,
      lessonsList: [],
      dataLoadState: false,
      nextLessonData: null,
      nextLessonName: "",
      nextProgressionId: null,
      lessonCount:0,
      lessonRate:0,
      notiFicationProgressRate: 0,
      notiFicationShow: false,
      liveProgressRate: 0,
      statusTab:null
    };
  },

  mixins: [fileMixin],

  watch:{
    '$route' (to, from){
      let getExamResult = this.$route.query.examresult;
      if(getExamResult == 'getscore') {
        this.fetchData()
      }
    },
  },

  mounted() {
    this.statusTab = this.$route.query.status;
    document.body.classList.remove('contentDarkMode');
    this.fetchData();
  },

  updated() {
    const ripples = [].map.call(
        document.querySelectorAll(".ripple-item"),
        function (el) {
          let ripple = new MDCRipple.attachTo(el);
          return ripple;
        }
    );
  },

  methods: {
    getMediaTypeString(lesson, code) {
      let codeType = this.$t('3735') + `<div class="rightDivider"></div>` + this.$t(code);
      return lesson.status.value === 'OPENED' && lesson.rate < 100 ? codeType : lesson.status.value === 'WAITING' && lesson.rate < 100 ? codeType : this.$t('146');
    },
    // 차시정보 API 호출 및 데이터 설정(get lesson list data)
    fetchData() {
      this.lessonsList = [];
      let params = this.setParams();

      //차시 정보
      this.$showLoading(this.$refs.lessonList);

      learnApi
          .learnViewCourses(params)
          .then((response) => {
            this.lessonData = response.data.data;

            // 과정의 차시 정보만 병합(merge lesson data)
            _.each(this.lessonData, (course) => {
              this.lessonsList = this.lessonsList.concat(course.lessons);
              this.lessonsList = this.lessonsList.filter(function (a) {
                return !this[a.id] && (this[a.id] = true);
              }, Object.create(null));
              this.lessonCount += parseInt(course.lessonCount);
            });
            this.lessonsList.forEach((value, index) => {
              this.lessonRate += parseInt(value.rate);
            });
            this.notiFicationProgressRate = this.lessonRate/this.lessonCount;
            if(this.notiFicationProgressRate<100){
              this.notiFicationShow = true;
            }
            this.$hideLoading();
            this.dataLoadState = true;
          })
          .catch((err) => {
            console.log(err);
          });

      // get next lesson
      learnApi.learnLessonNext(params).then((response) => {
        this.nextLessonData = response.data.data;
        // console.log('nextLessonData', this.nextLessonData);
        if (this.nextLessonData) {
          this.nextLessonName = this.nextLessonData.name;
          this.nextProgressionId = this.nextLessonData.progressionId;
          this.$emit("setNextLesson", this.nextLessonData);
        }

        this.$emit("setNextLesson", this.nextLessonData);
      });
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        learnId: this.$route.params.learnId,
      };
      return params;
    },

    // learn lesson
    learnLesson(lesson) {
      if (lesson.status.value === "OPENED") {
        if (lesson.contentsType.value === "EXAM_PAPER") {
          let query = this.$route.query;
          query.type='formal-evolution'
          this.$router.push({
            name: "LessonExamIntro",
            params: {
              learnId: this.$route.params.learnId,
              examineeId: lesson.examineeId,
            },
            query: query,
          });
        } else if(lesson.contentsType.value === 'LIVE_SESSION'){
          let params = {
            learnId: this.$route.params.learnId,
            progressionId: lesson.progressionId
          }
          learnApi.learnLessonContents(params).then((response) => {
            let liveSessionTrueFalse = response.data.data.liveSession.canParticipate
            if(liveSessionTrueFalse === false) {
              this.$alert({
                title: this.$t("3434"), // 학습을 중단한 강의입니다.
                content: this.$t("3435"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
                accept: this.$t("3436"), // 확인
              })
                  .then(() => {})
                  .catch(() => {});
            } else {
              let responseData = response.data.data
              let liveSessionData = responseData
              this.zoomMetting(lesson,liveSessionData)
            }
          }).catch((err) => {
          })

        } else {
          if(this.statusTab==='COMPLETION' && this.todayDate>this.basicData.periodLearning.end && this.todayDate>this.basicData.periodReview.start) {
            this.$alert({
              title: this.$t("1944"), // 학습을 중단한 강의입니다.
              content: this.$t("1945"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
              accept: this.$t("1946"), // 확인
            })
                .then(() => {})
                .catch(() => {});
          } else {
            this.$router.push({
              name: "LessonView",
              params: {
                learnId: this.$route.params.learnId,
                lessonId: lesson.id,
                progressionId: lesson.progressionId,
              },
              query: this.$route.query,
            });
          }
          // this.$router.push({
          //   name: "LessonView",
          //   params: {
          //     learnId: this.$route.params.learnId,
          //     lessonId: lesson.id,
          //     progressionId: lesson.progressionId,
          //   },
          //   query: this.$route.query,
          // });
        }
      } else if(this.statusTab === "WAITING"){
        if(this.todayDate<this.basicData.periodLearning.start) {
          this.$alert({
            title: this.$t("3431"), // 학습을 중단한 강의입니다.
            content: this.$t("3432"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
            accept: this.$t("3433"), // 확인
          })
              .then(() => {})
              .catch(() => {});
        }
      } else {

        this.$alert({
          //title: "Todo-순차학습 안내",
          content: this.$t("1885") + " " + this.$t("1886"),
          accept: this.$t("1887"),
        }).then(() => {
          // console.log('lesson',lesson);
          // this.$router.push({
          //   name: "LessonView",
          //   params: {
          //     learnId: this.$route.params.learnId,
          //     lessonId: lesson.id,
          //     progressionId: lesson.progressionId,
          //   },
          //   query: this.$route.query,
          // });
        });
      }
    },

    zoomMetting(lesson,liveSessionData,target='_blank', rel="noopener noreferrer"){
      window.open(liveSessionData.liveSession.url, target,rel);
      this.updateProgress(lesson)
    },

    updateProgress(lesson) {

      let params = {
        total: 0,
        current: 0,
        learnId: this.$route.params.learnId,
        progressionId: lesson.progressionId
      }
      let responseData = null
      learnApi.learnLessonProgression(params).then((response) => {
        responseData = response.data.data
        this.liveProgressRate = responseData.rate
        this.$router.go(this.$router.currentRoute)
        // this.$router.push({
        //     name: 'LearnView',
        //     params: {learnId: this.$route.params.learnId},
        //     query: this.$route.query
        // }).catch((err) => {})
      }).catch((err) => {})
    },

    convertTimeZone(time,zone){
      // let convertedDateAndAMAndPM =''
      // var aestTime = new Date(time * 1000).toLocaleString("en-US", {timeZone: zone});
      // aestTime = new Date(aestTime);
      // // console.log('aestTime',aestTime)
      // // console.log('zone',zone)

      // let convertedTimeZone = aestTime.toLocaleString().replace(/\//g, '-')
      // let res = convertedTimeZone.split(",");

      // let convertedDate = this.$moment(res[0],'DD-MM-YYYY').format('YY-MM-DD')
      // let convertedTime =  this.$moment(res[1],'hh:mm:ss').format('hh:mm A')
      // let splitConvertedTime =  this.$moment(res[1],'hh:mm:ss').format('hh:mm A').split(" ")
      // return convertedDateAndAMAndPM = convertedDate && splitConvertedTime[1]=='AM'? convertedDate +' '+ splitConvertedTime[0] +' '+ this.$t('3303'): convertedDate +' '+ splitConvertedTime[0] +' '+this.$t('3304')

      let convertedTimeZone    = this.$moment.tz(time * 1000, zone);
      let splitConvertedTime = convertedTimeZone.format('YY-MM-DD hh:mm A').split(" ")
      //console.log('splitConvertedTime',splitConvertedTime)
      return this.$moment(convertedTimeZone).format('L') +' '+ this.$moment(convertedTimeZone).format('LT') ;
      // if(splitConvertedTime[2]=='AM' || splitConvertedTime[2]=='오전' || splitConvertedTime[2]=='오전에' || splitConvertedTime[2]=='오전의' || splitConvertedTime[2]=='早上' || splitConvertedTime[2]=='早晨'|| splitConvertedTime[2]=='上午'|| splitConvertedTime[2]=='晨'|| splitConvertedTime[2]=='早'|| splitConvertedTime[2]=='朝') {
      //     return this.$t('3303',{'str1':`${splitConvertedTime[0]}`,'str2':`${splitConvertedTime[1]}`})
      // }

      // if(splitConvertedTime[2]=='PM' || splitConvertedTime[2]=='오후' || splitConvertedTime[2]=='저녁' || splitConvertedTime[2]=='저녁때' || splitConvertedTime[2]=='下午') {
      //     return this.$t('3304',{'str1':`${splitConvertedTime[0]}`,'str2':`${splitConvertedTime[1]}`})
      // }
    },
    convertTDuration(duration){
      let h = Math.floor(duration / 60);
      let m = duration % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return this.$t('3308',{'str1':`${h}`,'str2':`${m}`})
      //return `${h}:${m}`
    }

  },
};
</script>

<style scoped>
.material-icons.orange600 {
  color: var(--Secondary);
}
</style>
